import { render, staticRenderFns } from "./Caption.vue?vue&type=template&id=45ec8df1&"
import script from "./Caption.vue?vue&type=script&lang=js&"
export * from "./Caption.vue?vue&type=script&lang=js&"
import style0 from "./Caption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports